import client from '../../apollo';
import { gql } from '@apollo/client'
import apiClient from 'ps-components/lib/apiClient';
import flattenDeep from 'lodash/flattenDeep';

export const ADD_JOB = 'ADD_JOB';
export const CLEAR_JOBS_ONLY = 'CLEAR_JOBS_ONLY';
export const CLEAR_SELECTED_JOBS = 'CLEAR_SELECTED_JOBS';
export const CREATE_JOB_MATCH = 'CREATE_JOB_MATCH';
export const GET_RANDOM_PRICED_JOB_SUCCESS = 'GET_RANDOM_PRICED_JOB_SUCCESS';
export const SELECT_ALL_FILTERED_JOBS = 'SELECT_ALL_FILTERED_JOBS';
export const SET_JOB_CODE_KEYS = 'SET_JOB_CODE_KEYS';
export const SET_ORG_JOB_FACET_TEXT = 'SET_ORG_JOB_FACET_TEXT';
export const SET_SELECTED_JOB = 'SET_SELECTED_JOB';
export const TOGGLE_SELECT_ALL_ORG_JOBS = 'TOGGLE_SELECT_ALL_ORG_JOBS';
export const TOGGLE_SHOW_SELECTED_JOBS = 'TOGGLE_SHOW_SELECTED_JOBS';
export const TOGGLE_SELECTED_JOB = 'TOGGLE_SELECTED_JOB';
export const GET_JOB_UDFS_START = 'GET_JOB_UDFS_START';
export const GET_JOB_UDFS_SUCCESS = 'GET_JOB_UDFS_SUCCESS';
export const GET_JOB_UDFS_FAILED = 'GET_JOB_UDFS_FAILED';
export const UPDATE_JOB_MATCHES_VALUES_START = 'UPDATE_JOB_MATCHES_VALUES_START';
export const UPDATE_JOB_MATCHES_VALUES_SUCCESS = 'UPDATE_JOB_MATCHES_VALUES_SUCCESS';
export const UPDATE_JOB_MATCHES_VALUES_FAILED = 'UPDATE_JOB_MATCHES_VALUES_FAILED';
export const GET_ORG_JOBS_BY_ID_START = 'GET_ORG_JOBS_BY_ID_START';
export const GET_ORG_JOBS_BY_ID_SUCCESS = 'GET_ORG_JOBS_BY_ID_SUCCESS';
export const GET_ORG_JOBS_BY_ID_FAILED = 'GET_ORG_JOBS_BY_ID_FAILED';
export const GET_AGING_FACTORS_START = 'GET_AGING_FACTORS_START';
export const GET_AGING_FACTORS_SUCCESS = 'GET_AGING_FACTORS_SUCCESS';
export const GET_AGING_FACTORS_FAILED = 'GET_AGING_FACTORS_FAILED';
export const RESET_LOADING_STATE = 'ORG_JOBS_RESET_LOADING_STATE';
export const UPDATE_SELECTED_JOB_MATCHES = 'UPDATE_SELECTED_JOB_MATCHES';

export function resetOrgJobsLoading() {
  return { type: RESET_LOADING_STATE };
}

export function addJob(selectedJob) {
  return async dispatch => {
    dispatch({
      type: ADD_JOB,
      data: selectedJob
    });
  };
}
export function clearJobsOnly(first, after, searchCriteria) {
  return async dispatch => {
    let data = [];
    data = await dispatch(toggleAll(first, after, searchCriteria));

    dispatch({
      type: CLEAR_JOBS_ONLY,
      data: data
    });
  };
}
export function clearSelectedJobs() {
  return {
    type: CLEAR_SELECTED_JOBS
  };
}
export function createJobMatch(orgJobId, surveyJobCode, surveyCode) {
  return async dispatch => {
    try {
      const mutation = gql`
        mutation createJobMatch($orgJobId: ID!, $surveyJobCode: String!, $surveyCode: String!) {
          createJobMatch(orgJobId: $orgJobId, surveyJobCode: $surveyJobCode, surveyCode: $surveyCode) {
            id
            orgJob {
              id
              title
            }
            surveyJob {
              id
              title
              code
              description
              survey {
                id
                code
                name
              }
            }
          }
        }
      `;

      const { data } = await client.mutate({
        mutation,
        variables: {
          orgJobId,
          surveyJobCode,
          surveyCode
        }
      });

      dispatch({
        type: CREATE_JOB_MATCH,
        data: data.createJobMatch
      });
    } catch (error) {
      console.log(error);
    }
  };
}
export function deleteJobMatch(matchesToDelete, orgJobId) {
  return async dispatch => {
    try {
      await apiClient.apiPost('/api/market-pricing/global-job-matching/deleteMatches', { matchesToDelete });
      const jobMatchesResult = await getJobMatches(dispatch, orgJobId);
      const jobMatches = jobMatchesResult?.orgJob.jobMatches || [];
      dispatch({ type: UPDATE_SELECTED_JOB_MATCHES, jobMatches });
    } catch (error) {
      console.log(error);
    }
  };
}
export function getJobCodeKeys(selectedJob) {
  return async dispatch => {
    try {
      const response = await apiClient.apiPost('/api/market-pricing/global-job-matching/getJobCodeKeys', {
        jobCode: selectedJob.code
      });
      dispatch({ type: SET_JOB_CODE_KEYS, data: response.data.message.rows });
    } catch (error) {
      console.log(error);
    }
  };
}
export function getJobsByID(ids) {
  return async dispatch => {
    if (!ids) console.log('No ids provided to getJobsByID');

    try {
      dispatch({ type: GET_ORG_JOBS_BY_ID_START });
      const res = await apiClient.apiGet('/api/market-pricing/jobs/getJobs', {
        params: {
          orgJobIds: ids
        }
      });

      if (res && res.data && res.data.orgJobs) {
        const orgJobs = res.data.orgJobs.map(job => {
          return {
            id: job.orgJobId,
            code: job.orgJobCode,
            codeKey: job.orgJobCodeKey,
            title: job.orgJobTitle,
            description: job.orgJobDescription
          };
        });

        dispatch({ type: GET_ORG_JOBS_BY_ID_SUCCESS, jobs: orgJobs });
        return orgJobs;
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: GET_ORG_JOBS_BY_ID_FAILED });
    }
  };
}

function retrieveJobById(id, slotteeCheck, benchmarkYear) {
  return apiClient.apiGet('/api/market-pricing/jobs/getJobById', {
    params: {
      orgJobId: id,
      showNullMidpoint: true,
      slotteeCheck,
      benchmarkYear
    }
  });
}

export function getJobByID(id, slotteeCheck, benchmarkYear) {
  return async dispatch => {
    try {
      dispatch({ type: GET_ORG_JOBS_BY_ID_START });
      const res = await retrieveJobById(id, slotteeCheck, benchmarkYear);
      if (res.data.success && res.data.orgJob) {
        dispatch({ type: GET_ORG_JOBS_BY_ID_SUCCESS, jobs: [res.data.orgJob] });
        return res.data.orgJob;
      }
      throw Error('Could not retrieve org job');
    } catch (error) {
      console.log(error);
      dispatch({ type: GET_ORG_JOBS_BY_ID_FAILED });
    }
  };
}

export function getRandomPricedJob() {
  return async dispatch => {
    try {
      const res = await apiClient.apiGet('/api/market-pricing/jobs/getRandomPricedOrgJob');

      if (res && res.data.success) {
        dispatch({
          type: GET_RANDOM_PRICED_JOB_SUCCESS,
          orgJob: res.data.orgJob
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
}

export function selectAllFilteredJobs(first, after, searchCriteria) {
  return async dispatch => {
    const data = await dispatch(toggleAll(first, after, searchCriteria));

    dispatch({
      type: SELECT_ALL_FILTERED_JOBS,
      data: data
    });
  };
}
export function setOrgJobFacetText(text) {
  return async dispatch => {
    dispatch({
      type: SET_ORG_JOB_FACET_TEXT,
      data: text
    });
  };
}
export function setSelectedJob(job) {
  return async dispatch => {
    let id = job.orgJobId || job.id;

    try {
      // we assign job id of 0 to an ad hoc job by default,
      // so using this check to find out if the job is ad hoc in order to skip the api call
      if (typeof id === 'string') {
        id = parseInt(id);
      }
      if (id === 0) {
        const staticJob = { id: 0, code: job.code, codeKey: job.codeKey ?? ' ' };
        dispatch({ type: SET_SELECTED_JOB, data: staticJob });
        return staticJob;
      } else {
        const result = await retrieveJobById(id);
        if (result.data.success && result.data.orgJob) {
          const job = result.data.orgJob;
          const jobMatchesResult = await getJobMatches(dispatch, id);
          job.jobMatches = jobMatchesResult?.orgJob.jobMatches || [];
          dispatch({ type: SET_SELECTED_JOB, data: job });
          return job;
        }
      }
      throw Error('Could not retrieve org job');
    } catch (error) {
      console.log(error);
    }
  };
}
export function toggleAll(first, after, searchCriteria) {
  return async dispatch => {
    try {
      const calls = Math.ceil(first / 5000);
      const remainder = first % 5000;
      let last = after;
      let queryParameters = [];
      let data = [];
      if (calls === 1) {
        await apiClient
          .apiPost('/api/jobRanges/search/search', {
            limit: first,
            offset: after,
            include: searchCriteria.include,
            exclude: searchCriteria.exclude,
            es_query: searchCriteria.es_query
          })
          .then(resp => (data = resp.data.data))
          .catch(err => console.log('error selecting all orgJobs:', err));
      } else {
        for (let i = 0; i < calls; i++) {
          const set = {
            limit: i + 1 === calls ? remainder : 5000,
            offset: last,
            include: searchCriteria.include,
            exclude: searchCriteria.exclude
          };
          last += 5000;

          queryParameters.push(apiClient.apiPost('/api/jobRanges/search/search', { ...set }));
        }

        await Promise.all(queryParameters)
          .then(response => {
            data = response.map(datum => datum.data.data);
          })
          .catch(err => console.log('error selecting all orgJobs:', err));
      }

      return flattenDeep(data);
    } catch (error) {
      console.log(error);
    }
  };
}
export function toggleJobSelected(job, orgJobs) {
  return {
    type: TOGGLE_SELECTED_JOB,
    data: { job, orgJobs }
  };
}
export function toggleSelectAllOrgJobs(orgJobs) {
  return dispatch =>
    dispatch({
      type: TOGGLE_SELECT_ALL_ORG_JOBS,
      data: orgJobs
    });
}
export function toggleShowSelectedJobs() {
  return { type: TOGGLE_SHOW_SELECTED_JOBS };
}
export function updateJobMatches(selectedJob, matchesToAdd, matchesToDelete, editPastYears = false) {
  return async dispatch => {
    try {
      await apiClient.apiPost('/api/market-pricing/global-job-matching/updateMatches', {
        selectedJob,
        matchesToAdd,
        matchesToDelete,
        editPastYears
      });

      await getJobMatches(dispatch, selectedJob.id);
    } catch (error) {
      console.log(error);
    }
  };
}

export function updateJobMatchesValues(orgJobId, matches, metaData, benchmarkYear, editPastYears = false) {
  return async dispatch => {
    try {
      dispatch({ type: UPDATE_JOB_MATCHES_VALUES_START });
      const results = await apiClient.apiPut('/api/market-pricing/job-matches/updateMatches', {
        org_job_id: orgJobId,
        matches,
        metaData,
        benchmarkYear,
        editPastYears
      });
      if (results.data.success) {
        dispatch({ type: UPDATE_JOB_MATCHES_VALUES_SUCCESS, isSummaryUpdated: results.data.isSummaryUpdated === true });
        return results.data;
      } else {
        dispatch({ type: UPDATE_JOB_MATCHES_VALUES_FAILED });
        throw Error('Failed to update job matches');
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: UPDATE_JOB_MATCHES_VALUES_FAILED });
      throw error;
    }
  };
}
async function getJobMatches(dispatch, orgJobId) {
  // TODO remove graphql and change this to only retrieve job matches
  try {
    const query = gql`
      query orgJob($id: ID!) {
        orgJob(id: $id) {
          id
          name: title
          employeeCount
          description
          code
          codeKey
          currency
          descriptionDocument {
            title
            fileLocation
          }
          jobMatches {
            id
            isMeritMatch
            surveyJob {
              id
              title
              code
              description
              survey {
                id
                code
                name
              }
            }
            orgJob {
              id
            }
          }
        }
      }
    `;

    const { data } = await client.query({
      query,
      variables: { id: orgJobId },
      fetchPolicy: 'network-only'
    });

    return data;
  } catch (err) {
    console.error(err);
  }
}

export function getJobUserDefinedFields() {
  return async dispatch => {
    try {
      dispatch({ type: GET_JOB_UDFS_START });
      const result = await apiClient.apiGet('/api/util/user-defined-fields/getUdfs', {
        params: {
          udfType: 'jobs'
        }
      });

      if (result.data.success) {
        dispatch({ type: GET_JOB_UDFS_SUCCESS, userDefinedFields: result.data.udfs });
      }
    } catch (error) {
      dispatch({ type: GET_JOB_UDFS_FAILED });
      console.log(error);
    }
  };
}

export function getAgingFactors(currency, benchmarkYear) {
  return async dispatch => {
    try {
      dispatch({ type: GET_AGING_FACTORS_START });
      const result = await apiClient.apiGet('/api/market-pricing/jobs/agingFactors', {
        params: {
          currency,
          benchmarkYear
        }
      });
      dispatch({ type: GET_AGING_FACTORS_SUCCESS, agingFactors: result.data.agingFactors });
      return result.data.agingFactors;
    } catch (error) {
      dispatch({ type: GET_AGING_FACTORS_FAILED });
      console.log(error);
      throw error;
    }
  };
}
